export { formatLabel } from "./orderHelpers";

export const getPaymentStatusStyles = (status = "") => {
  const s = status.toString().toLowerCase();

  if (s.includes("complete") || s.includes("success") || s.includes("paid")) {
    return { bg: "bg-green-50", text: "text-green-700", ring: "ring-green-600/20", dot: "bg-green-500" };
  }
  if (s.includes("initiat") || s.includes("pending") || s.includes("process")) {
    return { bg: "bg-amber-50", text: "text-amber-700", ring: "ring-amber-600/20", dot: "bg-amber-500" };
  }
  if (s.includes("fail") || s.includes("cancel") || s.includes("reject")) {
    return { bg: "bg-red-50", text: "text-red-700", ring: "ring-red-600/20", dot: "bg-red-500" };
  }
  if (s.includes("refund")) {
    return { bg: "bg-orange-50", text: "text-orange-700", ring: "ring-orange-600/20", dot: "bg-orange-500" };
  }

  return { bg: "bg-gray-50", text: "text-gray-700", ring: "ring-gray-600/20", dot: "bg-gray-400" };
};

export const PAYMENT_STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "initiated", label: "Initiated" },
  { value: "completed", label: "Completed" },
  { value: "failed", label: "Failed" },
  { value: "pending", label: "Pending" },
  { value: "refunded", label: "Refunded" },
];

export const PAYMENT_METHOD_OPTIONS = [
  { value: "", label: "All Methods" },
  { value: "momo", label: "Mobile Money" },
  { value: "card", label: "Card" },
  { value: "bank", label: "Bank Transfer" },
];

export const PAYMENT_TYPE_OPTIONS = [
  { value: "", label: "All Types" },
  { value: "delivery", label: "Delivery" },
  { value: "pickup", label: "Pickup" },
];

export const PAYMENT_PURPOSE_OPTIONS = [
  { value: "", label: "All Purposes" },
  { value: "order_checkout", label: "Order Checkout" },
];
